import { Component, OnInit } from '@angular/core';
import { SectionService } from "../../../services/help/section.service";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { QuestionService } from "../../../services/help/question.service";
import { forkJoin } from "rxjs";
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Section } from '@app/models/help/section.model';
import { Question } from '@app/models/help/question.model';
import swal from "sweetalert";
import {ToastrService} from "ngx-toastr";
import {clonify} from "@app/shared/utils/object.utils";

@Component({
  selector: 'app-faqadmin',
  templateUrl: './faqadmin.component.html',
  styleUrls: ['./faqadmin.component.scss']
})
export class FaqAdminComponent implements OnInit {

  public sections: Section[];
  public questions: Question[];

  public count: number;
  public currentPage: number;
  public isFormOpen: boolean = false;
  public questionFormGroup: FormGroup;

  public question: Question = new Question();
  public isInUpdateMode: boolean = false;

  constructor(private sectionService: SectionService,
    private formBuilder: FormBuilder,
    private questionService: QuestionService,
    private toasterService: ToastrService,
    public ngxSmartModalService: NgxSmartModalService) {
    this.count = 0;
    this.currentPage = 0;
    this.createFormGroup();
  }

  public createFormGroup() {
    this.questionFormGroup = this.formBuilder.group({
      sectionId: [null, Validators.required],
      title: [null, Validators.required],
      answer: [null, Validators.required]
    });
  }

  public ngOnInit() {
    const sectionsCallback = this.sectionService.getList();
    const questionCallback = this.questionService.getList(0);

    forkJoin([sectionsCallback, questionCallback]).subscribe(
      ([sectionList, questionList]: [any, any]) => {
        this.sections = sectionList;
        this.questions = questionList.list;
        this.count = questionList.count;
      }
    );
  }

  public bindQuestions(page = 1) {
    this.questionService.getList(page).subscribe(result => {
      this.questions = result.list;
      this.count = result.count;
    });
  }

  public pageChanged(event): void {
    this.bindQuestions(event.page);
  }

  public newQuestion() {
    this.isFormOpen = !this.isFormOpen;
  }

  public getSectionName(id: number) {
    for (let section of this.sections) {
      if (section.id == id) {
        return section.title;
      }
    }
    return null;
  }

  public submitForm(form) {
    if (!this.questionFormGroup.valid) {
      return;
    }
    var process;

    this.question = { ...this.question, ...this.questionFormGroup.value };

    if (this.isInUpdateMode) {
      process = this.questionService.update(this.question);
    } else {
      process = this.questionService.insert(this.question);
    }

    process.subscribe(() => {
      this.bindQuestions();
      this.clearForm(form);
      this.currentPage = 1;
    });
    this.isInUpdateMode = false;

    this.toasterService.success('Record is updated.', 'FAQ');
  }

  public clearForm(form) {
    this.question = new Question();
    this.questionFormGroup.reset();
    form.resetForm();
  }

  public openSectionModal(event) {
    this.ngxSmartModalService.getModal('sectionModal').open();
    event.preventDefault();
  }

  public edit(question) {
    this.isFormOpen = true;
    this.question = clonify(question);
    this.questionFormGroup.patchValue(this.question);
    this.isInUpdateMode = true;
  }

  public delete(id) {
    swal({
      title: 'Are you sure?',
      text: '',
      icon: 'warning',
        buttons: {
          cancel: {
            text: 'No',
            visible: true,
            closeModal: true
          },
          confirm: {
            text: 'Yes',
            value: true,
            visible: true,
            className: 'bg-danger',
            closeModal: true
          }
        }
    }).then((isConfirm) => {
      if (isConfirm) {
        this.questionService.delete(id).subscribe(() => {
          this.bindQuestions();
          this.toasterService.info('Record is deleted.', 'FAQ');
          this.currentPage = 1;
        });
      }
    });
  }

  public updateSections(sections) {
    this.sections = sections;
  }
}
